export var MPARequestCall;
(function (MPARequestCall) {
    MPARequestCall["MPA_REQUEST_CALL_UPDATE"] = "MPA_REQUEST_CALL_UPDATE";
    MPARequestCall["MPA_REQUEST_CALL_DELETE"] = "MPA_REQUEST_CALL_DELETE";
    MPARequestCall["MPA_REQUEST_CALL_START"] = "MPA_REQUEST_CALL_START";
    MPARequestCall["MPA_REQUEST_CALL_STOP"] = "MPA_REQUEST_CALL_STOP";
    MPARequestCall["MPA_REQUEST_CALL_RESET_STREAM_CURSOR"] = "MPA_REQUEST_CALL_RESET_STREAM_CURSOR";
})(MPARequestCall || (MPARequestCall = {}));
